export enum MaterialsEnum {
  FILES = 1,
  IMAGES = 2,
  VIDEOS_YOUTUBE = 3,
  VIDEOS = 4,
  LEARN_AND_EARN = 5,
  PRODUCT_INFORMATION = 6,
  OFFICE_TOOLS = 7,
}
